import type { AxiosResponse } from 'axios';

import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { NonRecursiveSnakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize, snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import type { Image } from '@rover/types';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const deleteImage = async (url: string): Promise<boolean> => {
  const ai = getAxiosInstance();

  try {
    await ai.delete(url);
    return true;
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error deleting the image.');
  }
};
type RequestType = NonRecursiveSnakeify<Image>;
export const putImage = async (updatedImageData: Image): Promise<boolean> => {
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.put<RequestType, AxiosResponse<boolean>>(
      updatedImageData.url,
      snakeify(updatedImageData, true)
    );
    return camelize(data, true);
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error updating the image.');
  }
};
